import {apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/google-sheets/v1`;

const getOauthStep1Url = accountName => {
  return `${baseUrl}/oauth/step-1?product=custom-forms&name=${encodeURIComponent(accountName)}`;
};

const findAccounts = () => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/accounts`)
    .then(response => response.data);
};

const deleteAccount = id => {
  return acerillAuthenticatedAxios
    .delete(`${baseUrl}/accounts/${id}`)
    .then(response => response.data);
};

const findIntegrations = () => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/integrations`)
    .then(response => response.data);
};

const googleSheetsV1Client = {
  getOauthStep1Url,
  findAccounts,
  deleteAccount,
  findIntegrations,
};

export default googleSheetsV1Client;
